/* Meowtside: header shadow, product variant/bundle/gallery, mixed-color 2-ball bundle, sticky add to cart */
(function () {
  var header = document.querySelector('.mt-header');
  var scroller = document.querySelector('.page-wrapper');
  if (header) {
    var onScroll = function () {
      var y = Math.max(window.scrollY || 0, scroller ? scroller.scrollTop : 0);
      header.classList.toggle('is-stuck', y > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function d(n, dec, th, sep) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.length > 1 ? p[0] + sep + p[1] : p[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(value, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(value, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(value, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return d(value, 2, "'", '.');
      return d(value, 2, ',', '.');
    });
  }

  document.querySelectorAll('[data-mt-product]').forEach(function (root) {
    var fmt = root.getAttribute('data-money-format');
    var form = root.querySelector('form[action*="/cart/add"]');
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-compare]');
    var labelEl = root.querySelector('[data-mt-variant-label]');
    var qtyEl = root.querySelector('[data-mt-qty]');
    var atc = root.querySelector('[data-mt-atc]');
    var atcPrice = root.querySelector('[data-mt-atc-price]');
    var errorEl = root.querySelector('[data-mt-error]');
    var track = root.querySelector('[data-mt-track]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    var countEl = root.querySelector('[data-mt-count]');
    var sticky = document.querySelector('[data-mt-sticky="' + root.id + '"]');

    function current() { return root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"]'); }
    function qty() { var b = root.querySelector('input[name="mt_bundle"]:checked'); return b ? Number(b.value) : 1; }
    function bundleInput() { return root.querySelector('input[name="mt_bundle"]:checked'); }
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    /* bundle total = unit price x qty - the fixed bundle discount converted to the shopper's currency (matches Shopify's automatic discount) */
    function bundleTotal(price, q, offCents) { return Math.max(0, Math.round(price * q - Math.round(Number(offCents || 0) * rate))); }
    function offFor() { var b = bundleInput(); return b ? b.getAttribute('data-off') : 0; }
    function extraColor(n) { return root.querySelector('input[name="mt_color' + n + '"]:checked'); }

    function slides() { return track ? track.querySelectorAll('[data-media-id]') : []; }
    function goToSlide(el) { if (track && el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function goToMedia(id) { if (track) goToSlide(track.querySelector('[data-media-id="' + id + '"]')); }
    function currentIndex() {
      if (!track) return 0;
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }

    function update(fromVariant) {
      var v = current();
      if (!v) return;
      var price = Number(v.getAttribute('data-price'));
      var compare = Number(v.getAttribute('data-compare'));
      var q = qty();
      if (qtyEl) qtyEl.value = q;
      var total = formatMoney(bundleTotal(price, q, offFor()), fmt);
      if (priceEl) priceEl.textContent = total;
      if (atcPrice) atcPrice.textContent = total;
      if (compareEl) {
        if (compare > price) { compareEl.textContent = formatMoney(compare * q, fmt); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      root.querySelectorAll('[data-mt-bundle-price]').forEach(function (el) {
        el.textContent = formatMoney(bundleTotal(price, Number(el.getAttribute('data-qty')), el.getAttribute('data-off')), fmt);
      });
      root.querySelectorAll('[data-mt-bundle-was]').forEach(function (el) {
        el.textContent = formatMoney(price * Number(el.getAttribute('data-qty')), fmt);
      });
      if (labelEl && v.getAttribute('data-title')) labelEl.textContent = v.getAttribute('data-title');
      var names = [v.getAttribute('data-title')];
      root.querySelectorAll('[data-mt-color-extra]').forEach(function (box) {
        var n = Number(box.getAttribute('data-mt-color-extra'));
        box.hidden = q < n;
        var c = extraColor(n);
        var lbl = box.querySelector('[data-mt-extra-label]');
        if (c && lbl) lbl.textContent = c.getAttribute('data-title');
        if (q >= n) names.push(c ? c.getAttribute('data-title') : v.getAttribute('data-title'));
      });
      var available = v.type === 'hidden' || v.getAttribute('data-available') === 'true';
      if (atc) {
        atc.disabled = !available;
        var t = atc.querySelector('[data-mt-atc-text]');
        if (t) t.textContent = available ? atc.getAttribute('data-label') : 'Sold out';
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-mt-sticky-price]');
        var sv = sticky.querySelector('[data-mt-sticky-variant]');
        var sb = sticky.querySelector('button');
        if (sp) sp.textContent = total;
        if (sv && v.getAttribute('data-title')) sv.textContent = names.join(' + ');
        if (sb) sb.disabled = !available;
      }
      if (fromVariant) {
        if (v.getAttribute('data-media')) goToMedia(v.getAttribute('data-media'));
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.value);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'id') {
        /* extra balls follow ball 1 until the shopper opens their pickers */
        root.querySelectorAll('[data-mt-color-extra]').forEach(function (box) {
          if (!box.hidden) return;
          var n = box.getAttribute('data-mt-color-extra');
          var match = root.querySelector('input[name="mt_color' + n + '"][value="' + e.target.value + '"]');
          if (match) match.checked = true;
        });
        update(true);
      }
      if (e.target.name === 'mt_bundle' || /^mt_color\d$/.test(e.target.name)) update(false);
    });

    /* 2-ball bundle with two different colors: add both lines in one request */
    if (form) {
      form.addEventListener('submit', function (e) {
        var v = current();
        var q = qty();
        if (q < 2 || !v) return;
        var counts = {};
        counts[v.value] = 1;
        for (var n = 2; n <= q; n++) {
          var c = extraColor(n);
          var idv = c ? c.value : v.value;
          counts[idv] = (counts[idv] || 0) + 1;
        }
        var ids = Object.keys(counts);
        if (ids.length < 2) return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        if (atc) atc.setAttribute('aria-busy', 'true');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (k) { return { id: Number(k), quantity: counts[k] }; }) })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function (err) {
            if (atc) atc.removeAttribute('aria-busy');
            if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
          });
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToMedia(t.getAttribute('data-mt-thumb')); });
    });
    var prev = root.querySelector('[data-mt-prev]');
    var next = root.querySelector('[data-mt-next]');
    if (prev) prev.addEventListener('click', function () { var all = slides(); goToSlide(all[(currentIndex() - 1 + all.length) % all.length]); });
    if (next) next.addEventListener('click', function () { var all = slides(); goToSlide(all[(currentIndex() + 1) % all.length]); });

    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.getAttribute('data-media-id');
          if (countEl) countEl.textContent = en.target.getAttribute('data-index');
          thumbs.forEach(function (t) {
            var on = t.getAttribute('data-mt-thumb') === id;
            t.setAttribute('aria-current', on ? 'true' : 'false');
            if (on && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.offsetLeft - 40, behavior: 'smooth' });
          });
        });
      }, { root: track, threshold: 0.6 });
      slides().forEach(function (s) { io.observe(s); });
    }

    if (sticky && atc && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      });
      so.observe(atc);
    }

    var eta = root.querySelector('[data-mt-eta]');
    if (eta) {
      var addBiz = function (date, days) {
        var d = new Date(date.getTime());
        while (days > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) days--; }
        return d;
      };
      var start = new Date();
      var cutoff = Number(eta.getAttribute('data-cutoff') || 14);
      if (start.getDay() === 0 || start.getDay() === 6 || start.getHours() >= cutoff) start = addBiz(start, 1);
      var sMin = addBiz(start, Number(eta.getAttribute('data-ship-min'))), sMax = addBiz(start, Number(eta.getAttribute('data-ship-max')));
      var dMin = addBiz(sMin, Number(eta.getAttribute('data-del-min'))), dMax = addBiz(sMax, Number(eta.getAttribute('data-del-max')));
      var loc = document.documentElement.lang || undefined;
      var f = function (d) { try { return d.toLocaleDateString(loc, { month: 'short', day: 'numeric' }); } catch (x) { return d.toDateString().slice(4, 10); } };
      var range = function (a, b) { return f(a) === f(b) ? f(a) : f(a) + ' – ' + f(b); };
      eta.querySelector('[data-eta-ship]').textContent = range(sMin, sMax);
      eta.querySelector('[data-eta-deliver]').textContent = range(dMin, dMax);
    }

    update(false);
    /* deep link (?variant=…): open the gallery on that color's photo instead of the featured image */
    if (/[?&]variant=/.test(window.location.search) && track) {
      var v0 = current();
      var m0 = v0 && v0.getAttribute('data-media');
      var s0 = m0 && track.querySelector('[data-media-id="' + m0 + '"]');
      if (s0) track.scrollLeft = s0.offsetLeft - track.offsetLeft;
    }
  });
})();
